<template>
    <b-card class="shadow mb-3 p-2">
        <b-row>
            <b-col>

                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-grow-1"><span class="h2">{{ title }}</span></div>

                    <div class="d-flex flex-grow-1 mb-3">
                        <div class="d-flex justify-content-center flex-grow-0 flex-wrap p-2">
                            <b-form-radio v-model="breakdownType" @change="onBreakdownTypeChange" name="keeping-breakdown-types" value="1" class="mr-4">По типам контрактов</b-form-radio>
                            <b-form-radio v-model="breakdownType" @change="onBreakdownTypeChange" name="keeping-breakdown-types" value="2" class="mr-4">По видам животных</b-form-radio>
                        </div>
                    </div>

                    <div class="col-xs-12">
                            <transition name="fade" mode="out-in">
                                <div v-if="chartDataInitialized">
                                    <EventStatisticsBar :chart-data="chartData" style="max-width: 100%; height: 400px" class="mb-4"/>
                                    <offscreen-chart :title="title">
                                        <template #subtitle>
                                            <span v-if="breakdownType === 1">По типам контрактов</span><span v-if="breakdownType === 2">По видам животных</span>  (на {{ commonQueryParams['date'] }})
                                        </template>
                                        <template #chart>
                                            <EventStatisticsBar :chart-data="chartData" class="mb-4" style="width: 900px; height: 600px"/>
                                        </template>
                                    </offscreen-chart>
                                    <StatisticsTable :data="chartData" @on-value-clicked="onTableValueClicked"/>
                                </div>
                                <div v-else class="d-flex w-100 align-items-center justify-content-center" style="max-width: 100%; height: 400px">
                                    <b-spinner variant="info"/>
                                </div>
                            </transition>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import EventStatisticsLine from "@/pages/Statistics/EventStatisticsLine";
import {EventStatisticsMixin} from "@/pages/Statistics/eventStatisticsMixin";
import {EventKind} from "@/pages/AppPages/Events/event";
import StatisticsTable from "@/pages/Statistics/StatisticsTable.vue";
import EventStatisticsBar from "@/pages/Statistics/EventStatisticsBar";
import OffscreenChart from "@/pages/Statistics/OffscreenChart.vue";
import {TableActions} from "@/store/tables/constants";

export default {
    name: "KeepingStatistics",
    components: {OffscreenChart, EventStatisticsBar, StatisticsTable, EventStatisticsLine},
    mixins: [EventStatisticsMixin],
    computed: {
        title() {
            return 'Животные на содержании'
        }
    },
    methods: {
        getExtraParams() {
            return [
                {label: 'Количество животных, находящихся на содержании', borderColor: '#59a89c', backgroundColor: '#59a89c' },
            ];
        },
        onTableValueClicked(value) {
            const rowParams = value.rowParams;
            const colParams = value.colParams;

            let filters = [
                {'key': 'kind', 'value': EventKind.KEEPING, 'label': 'Содержание'},
                {'key': 'execution_date_to', 'value': rowParams['date'], 'label': 'Дата проведения не позднее ' + rowParams['date']},
                {'key': 'is_kept', 'value': true, 'label': 'Находится на содержании'}
            ];

            if (colParams && colParams['contract_type'] !== undefined) {
                filters.push({'key': 'contract_type', 'value': colParams['contract_type'] ? colParams['contract_type'] : 0, 'label': colParams['name']})
            }
            if (colParams && colParams['animal_species'] !== undefined) {
                filters.push({'key': 'animal_species', 'value': colParams['animal_species'], 'label': colParams['name']})
            }

            const tableName = 'common-events-table';
            this.$store.dispatch(TableActions.TABLE_SET_CURRENT_PAGE,
                { name: tableName, page: 1 })
                .then(() => {
                    return this.$store.dispatch(TableActions.TABLE_CHANGE_FILTERS,
                        { name: tableName, filterData: filters })
                })
                .then(() => {
                    window.open('/events', '_blank').focus();
                });
        },
    },
    beforeMount() {
        this.url = '/statistics/keeping/kept'
        this.breakdownType = 1
    }
}
</script>

<style scoped>

</style>